export const CREATE_LOCATION = 'CREATE_LOCATION';
export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const FETCH_LOCATION = 'FETCH_LOCATION';
export const EDIT_LOCATION = 'EDIT_LOCATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';
